module.exports = __webpack_public_path__ + "static/media/skills.5224b941.svg";